/*
 * Ryan O'Dowd
 * 2025-08-29
 * © Copyright 2025 Oakwood Software Consulting, Inc.  All Rights Reserved.
 */

const getStyles = ({colors}) => {
  return {
    adminSettingsWrapper: {
      backgroundColor: colors.primaryExtraLight,
    },
    adminOptionsInner: {
      flex: 1,
    },
  };
};

export default getStyles;
